import { BaseObjectDto } from "../../../core/business-objects/base-object/base-object.dto";
import { DtoInclude } from "../../../core/store/dto/dto";

export class ControlTypeDto extends BaseObjectDto {
    @DtoInclude
    name: string;
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/control-type/control-type.dto.ts